import React from 'react';

const PublicReportView = ({ report, modules, channels, sampler, formatDate }) => {
    return (
        <div className="summary-content">
            {/* Imagen */}
            <div className="h-100">
                {report.image_name ? (
                    <img
                        src={`https://storage.googleapis.com/app-techcomp.appspot.com/${report.image_name}`}
                        alt="Vista previa"
                        className="card-img-top"
                    />
                ) : (
                    <p>No se ha cargado ninguna imagen.</p>
                )}
                <div className="card-body">
                    <div className="row gx-0">
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <p className="card-text mb-0">
                                <strong>S/N:</strong> {report.serialNumber || "No especificado"}
                            </p>
                            <p className="card-text mb-0">
                                <strong>Brand:</strong> {report.brand || "No especificado"}
                            </p>
                            <p className="card-text mb-0">
                                <strong>Model:</strong> {report.model || "No especificado"}
                            </p>
                        </div>
                        <br/>
                        <p className="card-text mt-5">
                            <strong>Engineer Name:</strong> {report.engineer_name || "No especificado"}
                        </p>
                    </div>
                </div>
            </div>

            {/* Mostrar información dependiendo del modelo */}
            {report.brand === "Scion Instruments" && report.model === "LC6000" ? (
                <ModulesSection modules={modules} />
            ) : (
                <>
                    <ChannelsSection channels={channels} />
                    <SamplerSection sampler={sampler} />
                </>
            )}

            {/* Información Adicional */}
            <AdditionalInfoSection report={report} formatDate={formatDate} />

            {/* Botón para descargar la imagen */}
            {report.image_name && (
                <div className="text-center">
                    <button
                        className="btn btn-primary btn-next waves-effect waves-light"
                        onClick={() => {
                            const link = document.createElement("a");
                            link.href = `https://storage.googleapis.com/app-techcomp.appspot.com/${report.image_name}`;
                            link.download = report.image_name;
                            link.click();
                        }}
                    >
                        Download image
                    </button>
                </div>
            )}
        </div>
    );
};

const ModulesSection = ({ modules }) => (
    <div className="card-body pb-0 pt-0">
        <hr className="container-m-nx mb-4" />
        <div className="card-subtitle mb-3">
            <strong style={{ color: '#043268' }}>Modules</strong>
        </div>
        <div className="mt-3">
            {modules
                .reduce((acc, module) => {
                    if (module.module_name === "Detector") {
                        acc.detectores.push(module);
                    } else {
                        acc.otros.push(module);
                    }
                    return acc;
                }, { otros: [], detectores: [] })
                .otros.map((module, index) => (
                    <div key={index} className="mb-3">
                        <strong>{module.module_name}:</strong>
                        <p className="ms-3">
                            {module.module_value || "No especificado"}
                            {module.module_serial_number && (
                                <span>
                                    <br />
                                    <strong>Serial Number:</strong> {module.module_serial_number}
                                </span>
                            )}
                        </p>
                    </div>
                ))}

            {/* Detectores */}
            {modules.reduce((acc, module) => {
                if (module.module_name === "Detector") {
                    acc.push(module);
                }
                return acc;
            }, []).length > 0 && (
                <div className="mb-3">
                    <strong>Detector:</strong>
                    <ul className="ms-3">
                        {modules
                            .filter((module) => module.module_name === "Detector")
                            .map((detector, index) => (
                                <li key={index}>
                                    {detector.module_value || "No especificado"}
                                    {detector.module_serial_number && (
                                        <span>
                                            <br />
                                            <strong>Serial Number:</strong> {detector.module_serial_number}
                                        </span>
                                    )}
                                </li>
                            ))}
                    </ul>
                </div>
            )}
        </div>
        <hr className="container-m-nx mb-4" />
    </div>
);

const ChannelsSection = ({ channels }) => (
    <>
        {channels.length > 0 && (
            <div className="card-body pb-0">
                {channels.map((channel, index) => (
                    <div key={index} className="summary-channel">
                        <div className="card-subtitle mb-3">
                            <strong style={{color:'#043268'}}>Channel {channel.channel_title || "No especificado"}</strong>
                        </div>
                        <p className="card-text">
                            <strong>Inyector:</strong>{" "}
                            {channel.injector || "No especificado"}
                        </p>
                        <p>
                            <strong>Detector:</strong>{" "}
                            {channel.detector || "No especificado"}
                            {" "}   
                            {["SCD", "SQ", "TQ"].includes(channel.detector) && (
                                <>
                                    <strong>Detector S/N:</strong>{" "}
                                    {channel.detector_serial_number || "No especificado"}
                                </>
                            )}
                        </p>
                        <div className="card-subtitle mb-3">
                            <strong>Columns</strong>
                        </div>
                        <p>
                            <strong>Part Number:</strong>{" "}
                            {channel.column_pn || "No especificado"}
                        </p>
                        <p>
                            <strong>Description:</strong>{" "}
                            {channel.column_description || "No especificado"}
                        </p>
                        <hr className="container-m-nx mb-4" />
                    </div>
                ))}
            </div>
        )}
    </>
);

const SamplerSection = ({ sampler }) => (
    <>
        {Array.isArray(sampler) && sampler.length > 0 && (
            <div className="card-body pt-0">
                <div className="card-subtitle mb-3">
                    <strong style={{ color: '#043268' }}>Samplers</strong>
                </div>
                {sampler.map((samplerItem, index) => (
                    <div key={index} className="mb-4">
                        <p className="card-text">
                            <strong>Sampler {index + 1} - Type:</strong>{" "}
                            {samplerItem.sampler_type || "No especificado"}
                        </p>
                        {samplerItem.sampler_type === "OTHER" && (
                            <p className="card-text">
                                <strong>Sampler {index + 1} - Name:</strong>{" "}
                                {samplerItem.sampler_name || "No especificado"}
                            </p>
                        )}
                        <p className="card-text">
                            <strong>Sampler {index + 1} - Serial Number:</strong>{" "}
                            {samplerItem.sampler_serial_number || "No especificado"}
                        </p>
                        <p className="card-text">
                            <strong>Sampler {index + 1} - Description:</strong>{" "}
                            {samplerItem.sampler_description || "No especificado"}
                        </p>
                        {index < sampler.length - 1 && <hr className="container-m-nx" />}
                    </div>
                ))}
            </div>
        )}
    </>
);

const AdditionalInfoSection = ({ report, formatDate }) => (
    <div className="card-body pt-0">
        <div className="card-subtitle mb-3">
            <strong style={{color:'#043268'}}>Additional Information</strong>
        </div>
        <p>
            <strong>Date of Service:</strong>{" "}
            {report.service_date ? formatDate(report.service_date) : "No especificado"}
        </p>
        <p>
            <strong>Type of Service:</strong>{" "}
            {report.service_type || "No especificado"}
        </p>
        <p>
            <strong>General Description:</strong>{" "}
            {report.general_description || "No especificado"}
        </p>
        <hr className="container-m-nx mb-4" />
    </div>
);

export default PublicReportView;